/** Barra "Stai lavorando per: …" con selettore azienda per i gestori multi azienda. */
import { useQuery } from "@tanstack/react-query";
import { Building2, ArrowLeftRight } from "lucide-react";

import { endpoints } from "@/api/client";
import { Button } from "@/components/ui/button";
import { enterAzienda, exitAzienda, getAziendaId } from "@/lib/azienda";

export function AziendaBar() {
  const aziendaId = getAziendaId();
  const statusQ = useQuery({
    queryKey: ["billing-status"],
    queryFn: endpoints.billing.status,
    staleTime: 10_000,
    enabled: Boolean(aziendaId),
  });
  const listQ = useQuery({
    queryKey: ["gestore-aziende"],
    queryFn: endpoints.gestore.aziende,
    staleTime: 60_000,
    enabled: Boolean(aziendaId),
  });

  const s = statusQ.data;
  if (!aziendaId || !s?.managed_by) return null;

  const options = (listQ.data?.aziende ?? []).filter(
    (a) => a.status === "active" || a.status === "deactivating"
  );

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-sky-500/40 bg-sky-500/10 px-4 py-2 text-sm">
      <span className="flex items-center gap-2">
        <Building2 className="h-4 w-4 shrink-0 text-sky-700" />
        <span>
          Stai lavorando per: <strong>{s.azienda?.ragione_sociale ?? "azienda"}</strong>
          {s.azienda?.piva && <span className="text-muted-foreground"> · P.IVA {s.azienda.piva}</span>}
        </span>
      </span>
      <span className="flex items-center gap-2">
        {options.length > 1 && (
          <label className="flex items-center gap-1 text-xs">
            <ArrowLeftRight className="h-3.5 w-3.5" />
            <select
              className="rounded-md border bg-background px-2 py-1 text-sm"
              value={aziendaId}
              onChange={(e) => {
                if (e.target.value && e.target.value !== aziendaId) enterAzienda(e.target.value);
              }}
              aria-label="Cambia azienda"
            >
              {options.map((a) => (
                <option key={a.id} value={a.id}>
                  {a.ragione_sociale}
                </option>
              ))}
            </select>
          </label>
        )}
        <Button size="sm" variant="outline" onClick={() => exitAzienda()}>
          Torna alle mie aziende
        </Button>
      </span>
    </div>
  );
}
